import { render } from "./reporte_compraViews.vue?vue&type=template&id=86cff910&scoped=true"
import script from "./reporte_compraViews.vue?vue&type=script&lang=js"
export * from "./reporte_compraViews.vue?vue&type=script&lang=js"

import "./reporte_compraViews.vue?vue&type=style&index=0&id=86cff910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86cff910"]])

export default __exports__